import PropTypes from 'prop-types'
import Pill from '../FlowDiagram/Pill'

// Renders the main SV Theme node (black pill) with label below
const MainThemeNode = ({ node, isHovered, onNodeHover, onNodeLeave, onNodeMove }) => {
  const { x, y, w, h, fill, textColor } = node
  const centerX = x + w / 2
  const labelY = y + h + 10

  return (
    <g>
      {/* Black pill */}
      <Pill
        x={x}
        y={y}
        w={w}
        h={h}
        fill={fill}
        text=""
        textColor={textColor}
        isHovered={isHovered}
        onMouseEnter={event => onNodeHover(node, event)}
        onMouseLeave={onNodeLeave}
        onMouseMove={onNodeMove}
      />

      {/* SV Theme label below pill */}
      <text
        x={centerX}
        y={labelY}
        textAnchor="middle"
        dominantBaseline="hanging"
        fontSize={17}
        fontWeight={400}
        fontStyle="normal"
        fill="#111"
        style={{ pointerEvents: 'none' }} // Prevent interference with pill hover
      >
        Vision 2030
      </text>
    </g>
  )
}

MainThemeNode.propTypes = {
  node: PropTypes.shape({
    id: PropTypes.string.isRequired,
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    w: PropTypes.number.isRequired,
    h: PropTypes.number.isRequired,
    fill: PropTypes.string.isRequired,
    textColor: PropTypes.string
  }).isRequired,
  isHovered: PropTypes.bool,
  onNodeHover: PropTypes.func.isRequired,
  onNodeLeave: PropTypes.func.isRequired,
  onNodeMove: PropTypes.func.isRequired
}

export default MainThemeNode
